import type { Component, InjectionKey, Ref } from "vue";

import type DocPreview from "~/components/docs/DocPreview.vue";
import type RecurrenceEditor from "~/components/dumb/RecurrenceEditor.vue";
import type SkillCard from "~/components/dumb/SkillCard.vue";
import type TaskCard from "~/components/dumb/TaskCard.vue";
import type UserCard from "~/components/dumb/UserCard.vue";
import type DartboardCellEditor from "~/components/visualization/list/cellEditors/DartboardCellEditor.vue";
import type DuidCellEditor from "~/components/visualization/list/cellEditors/DuidCellEditor.vue";
import type OrderCellEditor from "~/components/visualization/list/cellEditors/OrderCellEditor.vue";
import type PriorityCellEditor from "~/components/visualization/list/cellEditors/PriorityCellEditor.vue";
import type SelectCellEditor from "~/components/visualization/list/cellEditors/SelectCellEditor.vue";
import type SizeCellEditor from "~/components/visualization/list/cellEditors/SizeCellEditor.vue";
import type TaskKindCellEditor from "~/components/visualization/list/cellEditors/TaskKindCellEditor.vue";
import type TimeTrackingCellEditor from "~/components/visualization/list/cellEditors/TimeTrackingCellEditor.vue";
import type TitleCellEditor from "~/components/visualization/list/cellEditors/TitleCellEditor.vue";
import type ConfigHeaderRenderer from "~/components/visualization/list/headerRenderers/ConfigHeaderRenderer.vue";
import type NewTaskHeaderRenderer from "~/components/visualization/list/headerRenderers/NewTaskHeaderRenderer.vue";
import type StandardHeaderRenderer from "~/components/visualization/list/headerRenderers/StandardHeaderRenderer.vue";

export const CONFIG_HEADER_RENDERER: InjectionKey<typeof ConfigHeaderRenderer> = Symbol("ConfigHeaderRenderer");
export const DARTBOARD_CELL_EDITOR: InjectionKey<typeof DartboardCellEditor> = Symbol("DartboardCellEditor");
export const DUID_CELL_EDITOR: InjectionKey<typeof DuidCellEditor> = Symbol("DuidCellEditor");
export const NEW_TASK_HEADER_RENDERER: InjectionKey<typeof NewTaskHeaderRenderer> = Symbol("NewTaskHeaderRenderer");
export const ORDER_CELL_EDITOR: InjectionKey<typeof OrderCellEditor> = Symbol("OrderCellEditor");
export const PRIORITY_CELL_EDITOR: InjectionKey<typeof PriorityCellEditor> = Symbol("PriorityCellEditor");
export const SELECT_CELL_EDITOR: InjectionKey<typeof SelectCellEditor> = Symbol("SelectCellEditor");
export const SIZE_CELL_EDITOR: InjectionKey<typeof SizeCellEditor> = Symbol("SizeCellEditor");
export const STANDARD_HEADER_RENDERER: InjectionKey<typeof StandardHeaderRenderer> = Symbol("StandardHeaderRenderer");
export const TASK_KIND_CELL_EDITOR: InjectionKey<typeof TaskKindCellEditor> = Symbol("TaskKindCellEditor");
export const TIME_TRACKING_CELL_EDITOR: InjectionKey<typeof TimeTrackingCellEditor> = Symbol("TimeTrackingCellEditor");
export const TITLE_CELL_EDITOR: InjectionKey<typeof TitleCellEditor> = Symbol("TitleCellEditor");

export const DOC_PREVIEW: InjectionKey<typeof DocPreview> = Symbol("DocPreview");
export const RECURRENCE_EDITOR: InjectionKey<typeof RecurrenceEditor> = Symbol("RecurrenceEditor");
export const SKILL_CARD: InjectionKey<typeof SkillCard> = Symbol("SkillCard");
export const TASK_CARD: InjectionKey<typeof TaskCard> = Symbol("TaskCard");
export const USER_CARD: InjectionKey<typeof UserCard> = Symbol("UserCard");

export const DROPDOWN_PARENT_ON_AFTER_OPEN_FUNCTION: InjectionKey<() => void> = Symbol(
  "DropdownParentOnAfterOpenFunction"
);
export const DROPDOWN_PARENT_ON_AFTER_CLOSE_FUNCTION: InjectionKey<() => void> = Symbol(
  "DropdownParentOnAfterCloseFunction"
);
export const DROPDOWN_NESTING_LEVEL: InjectionKey<number> = Symbol("DropdownNestingLevel");
export const DROPDOWN_ROOT_REFERENCE_NODE_GETTER: InjectionKey<() => Component | Element | null> = Symbol(
  "DropdownRootReferenceNodeGetter"
);
export const DROPDOWN_REGISTER_SUBDROPDOWN_STATE: InjectionKey<(itemIndex: number, isOpen: boolean) => void> = Symbol(
  "DropdownRegisterSubdropdownState"
);

export const GLOBAL_POPPER_PARENT_ID: InjectionKey<Ref<number | null>> = Symbol("GlobalPopperParentId");
export const IS_STANDALONE_MEDIA: InjectionKey<boolean> = Symbol("IsStandaloneMedia");
